import React, { useState, useEffect } from 'react';

export const BackToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div 
      className={`fixed bottom-10 right-6 md:right-12 z-[90] transition-all duration-300 transform ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
      }`}
    >
      <button
        onClick={scrollToTop}
        className="btn-8bit !p-3 md:!p-4 shadow-[4px_4px_0px_0px_#b026ff] hover:shadow-[6px_6px_0px_0px_#b026ff] group flex items-center justify-center"
        aria-label="Back to Top"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24" 
          strokeWidth={3} 
          stroke="currentColor" 
          className="w-6 h-6 transform group-hover:-translate-y-1 transition-transform"
        >
          <path strokeLinecap="square" strokeLinejoin="miter" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
        </svg>
      </button>
      
      {/* Small decorative label for desktop */}
      <span className="hidden md:block absolute -top-8 left-1/2 -translate-x-1/2 font-mono text-[8px] text-acid opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap tracking-widest uppercase pointer-events-none">
        UP_LINK
      </span>
    </div>
  );
};